import { render, staticRenderFns } from "./AddContactDialog.vue?vue&type=template&id=655fe4a4&scoped=true"
import script from "./AddContactDialog.vue?vue&type=script&lang=js"
export * from "./AddContactDialog.vue?vue&type=script&lang=js"
import style0 from "./AddContactDialog.vue?vue&type=style&index=0&id=655fe4a4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655fe4a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655fe4a4')) {
      api.createRecord('655fe4a4', component.options)
    } else {
      api.reload('655fe4a4', component.options)
    }
    module.hot.accept("./AddContactDialog.vue?vue&type=template&id=655fe4a4&scoped=true", function () {
      api.rerender('655fe4a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/components/AddContactDialog.vue"
export default component.exports